module.exports = __webpack_public_path__ + "img/482.fe07684e.jpg";